import { isGivenNameFirst } from '@fs/identity.js'
import { i18n } from '@fs/zion-locale'

export const formatTextWithDetail = (text, detail) => {
  // only return one part in case both parts have not loaded yet
  if (!text) {
    return detail
  }
  if (!detail) {
    return text
  }
  return `${text} • ${detail}`
}

export function formatFullName({ givenNames = '', surnames = '' }) {
  if (!givenNames) {
    return surnames
  }
  if (!surnames) {
    return givenNames
  }
  return isGivenNameFirst(i18n.language) ? `${givenNames} ${surnames}` : `${surnames} ${givenNames}`
}
